// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2r4Hp","signatureBlock":"Footer_signatureBlock__2xBYw","signature":"Footer_signature__3b09t"};